module.exports = __webpack_public_path__ + "img/audio_classify9.1783529d.png";